(() => {
  'use strict';
  if (window.MiniPowerVorkasse) { window.MiniPowerVorkasse.init(); return; }
  const instances = new Map();
  const money = cents => new Intl.NumberFormat('de-DE', {style:'currency', currency:'EUR'}).format(cents / 100);
  const offer = () => {
    // Scala renders its active configuration as a Ruby hash in the app embed.
    try {
      const template = document.querySelector('#scala-button-template');
      const config = JSON.parse(document.querySelector('#scala-button-restrict')?.content.querySelector('[data-kind="config"]')?.textContent.replace(/=>/g, ':') || '{}');
      const rate = Number(config.discountValue);
      if (!template || !Number(template.dataset.hasconfig) || config.id !== '1' || config.discountType !== 'percent' || config.contextType !== 'All' || !(rate > 0 && rate < 100) || !config.paymentMethods?.some(method => /vorkasse/i.test(method))) return null;
      const now = Date.now();
      if (template.dataset.startdate && now < Date.parse(template.dataset.startdate)) return null;
      if (template.dataset.enddate && now > Date.parse(template.dataset.enddate)) return null;
      return {...config, rate};
    } catch (_) { return null; }
  };
  const requestCart = async (path, payload) => {
    const response = await fetch((window.Shopify?.routes?.root || '/') + path, {method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json', 'X-Scala-Internal':'1'}, body:JSON.stringify(payload)});
    const data = await response.json();
    if (!response.ok || data.status >= 400) {
      const error = new Error(typeof data.description === 'string' ? data.description : 'Der Warenkorb konnte nicht aktualisiert werden. Bitte prüfe die Verfügbarkeit deiner Auswahl.');
      error.rejected = true;
      throw error;
    }
    return data;
  };
  const init = () => document.querySelectorAll('[data-mp-vorkasse]').forEach(element => {
    if (instances.has(element)) return;
    const root = element.closest('[data-mp-product-root]');
    const buybox = element.closest('[data-mp-buybox]');
    const form = element.closest('form[action*="/cart/add"]');
    if (!root || !buybox || !form) return;
    const opener = element.querySelector('[data-mp-vorkasse-open]');
    const dialog = element.querySelector('[data-mp-vorkasse-dialog]');
    const confirm = element.querySelector('[data-mp-vorkasse-confirm]');
    const errorNode = element.querySelector('[data-mp-vorkasse-error]');
    let busy = false, added = false, uncertain = false, addedSelectionKey = '';
    const selectionKey = items => JSON.stringify(items.map(item => ({...item, properties:Object.fromEntries(Object.entries(item.properties || {}).filter(([key]) => key !== '_mp_set_id'))})));
    const price = id => window.MiniPowerTax?.getVariantDisplayCents?.(id, null);
    const selectedId = () => { const input = form.querySelector('[name="id"]'); return input && !input.disabled ? input.value : null; };
    const showError = message => { errorNode.textContent = message; errorNode.hidden = !message; };
    const readSelection = () => {
      if (buybox.dataset.mpEmailOnly === 'true' || root.dataset.mpSetCheckoutBlocked === 'true' || form.querySelector('[data-mp-add]')?.matches(':disabled')) throw new Error('Diese Auswahl ist momentan nicht bestellbar. Bitte prüfe Produkt und Zubehör.');
      if (!window.MiniPowerTax?.buildProductCartItems) throw new Error('Die Produktauswahl wird geladen. Bitte versuche es erneut.');
      const items = window.MiniPowerTax.buildProductCartItems(form);
      if (!items.length) throw new Error('Bitte wähle eine verfügbare Produktvariante.');
      const rows = items.map((item, index) => {
        const cents = price(item.id);
        if (!Number.isSafeInteger(cents) || cents < 0 || !Number.isSafeInteger(item.quantity) || item.quantity < 1) throw new Error('Ein Zubehörpreis konnte nicht geladen werden. Bitte lade die Seite neu.');
        const accessory = [...root.querySelectorAll('[data-accessory-row]')].find(row => String(window.MiniPowerTax.getMappedVariantId(row.dataset.variantId)) === String(item.id));
        const cableOptions = JSON.parse(root.querySelector('[data-mp-set-cable-options]')?.textContent || '{}').options || [];
        const cable = cableOptions.find(option => option.variantId && String(window.MiniPowerTax.getMappedVariantId(option.variantId)) === String(item.id));
        const name = index === 0 ? element.dataset.productTitle : accessory?.querySelector('.mp-accessories__info label, .mp-accessories__info a')?.textContent.trim() || (cable ? `${cable.kind.toUpperCase()}-Kabel: ${cable.label}` : 'Gewähltes Set-Zubehör');
        return {name, quantity:item.quantity, cents:cents * item.quantity};
      });
      return {items, rows, subtotal:rows.reduce((total, row) => total + row.cents, 0)};
    };
    const drawQuote = config => {
      const selection = readSelection();
      const list = element.querySelector('[data-mp-vorkasse-items]');
      list.replaceChildren();
      selection.rows.forEach(row => {
        const li = document.createElement('li'), label = document.createElement('span'), amount = document.createElement('span');
        label.textContent = `${row.quantity} × ${row.name}`; amount.textContent = money(row.cents);
        li.append(label, amount); list.append(li);
      });
      const saving = Math.floor(selection.subtotal * config.rate / 100);
      element.querySelector('[data-mp-vorkasse-subtotal]').textContent = money(selection.subtotal);
      element.querySelector('[data-mp-vorkasse-total-saving]').textContent = '− ' + money(saving);
      element.querySelector('[data-mp-vorkasse-total]').textContent = money(selection.subtotal - saving);
      return selection;
    };
    const refresh = () => {
      if (busy) return;
      const config = offer(), id = selectedId(), cents = price(id);
      const currency = document.getElementById('mp-tax-selector')?.dataset.currency || element.dataset.currency;
      const visible = config && currency === 'EUR' && Number.isSafeInteger(cents) && cents > 0 && (element.dataset.formerPickup === 'true' || cents > 80000) && buybox.dataset.mpEmailOnly !== 'true';
      element.hidden = !visible;
      if (!visible) { if (dialog.open) dialog.close(); return; }
      const saving = Math.floor(cents * config.rate / 100);
      element.querySelector('[data-mp-vorkasse-regular]').textContent = money(cents);
      element.querySelector('[data-mp-vorkasse-price]').textContent = money(cents - saving);
      element.querySelector('[data-mp-vorkasse-saving]').textContent = money(saving);
      element.querySelectorAll('[data-mp-vorkasse-rate]').forEach(node => node.textContent = config.rate + ' %');
    };
    opener.addEventListener('click', () => {
      refresh(); if (element.hidden) return;
      showError('');
      confirm.disabled = uncertain;
      confirm.textContent = added ? 'Vorkasse-Kasse erneut öffnen' : 'Weiter zur Vorkasse-Kasse';
      let selection;
      try { selection = drawQuote(offer()); } catch (error) { showError(error.message); confirm.disabled = true; }
      if (uncertain) showError('Die letzte Warenkorb-Anfrage konnte nicht bestätigt werden. Bitte prüfe zuerst deinen Warenkorb, bevor du Artikel erneut hinzufügst.');
      if (added) showError('Deine Auswahl wurde bereits hinzugefügt. Der nächste Versuch öffnet den bestehenden Warenkorb mit Vorkasse.');
      if (added && selection && selectionKey(selection.items) !== addedSelectionKey) {
        showError('Deine vorherige Auswahl ist bereits im Warenkorb. Bitte prüfe den Warenkorb, bevor du eine andere Auswahl hinzufügst.');
        confirm.disabled = true;
      }
      dialog.showModal();
    });
    const close = () => { if (!busy) dialog.close(); };
    element.querySelector('[data-mp-vorkasse-close]').addEventListener('click', close);
    dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
    dialog.addEventListener('close', () => opener.focus({preventScroll:true}));
    confirm.addEventListener('click', async () => {
      if (busy || uncertain) return;
      const config = offer();
      if (!config) { showError('Vorkasse ist momentan nicht verfügbar. Bitte versuche es später erneut.'); return; }
      if (!form.reportValidity()) return;
      let selection;
      try {
        selection = drawQuote(config);
        if (added && selectionKey(selection.items) !== addedSelectionKey) throw new Error('Deine vorherige Auswahl ist bereits im Warenkorb. Bitte prüfe zuerst deinen Warenkorb.');
      } catch (error) { showError(error.message); return; }
      busy = true; confirm.disabled = true; dialog.setAttribute('aria-busy', 'true');
      confirm.textContent = 'Vorkasse-Kasse wird geöffnet …'; showError('');
      let adding = false;
      try {
        if (!added) {
          adding = true;
          await requestCart('cart/add.js', {items:selection.items});
          added = true; addedSelectionKey = selectionKey(selection.items); adding = false;
        }
        // Same persisted cart attribute as the installed Scala Vorkasse button.
        const cart = await requestCart('cart/update.js', {attributes:{_scaladiscount:config.id}});
        const applied = cart.cart_level_discount_applications?.some(entry => entry.discount_application?.title === config.message && Number(entry.discount_application?.value) === config.rate);
        if (cart.attributes?._scaladiscount !== config.id || !applied) throw new Error('Der Vorkasserabatt konnte nicht bestätigt werden. Deine Artikel sind im Warenkorb. Bitte prüfe den Warenkorb oder versuche es erneut.');
        const checkout = new URL((window.Shopify?.routes?.root || '/') + 'checkout', location.origin);
        checkout.searchParams.set('skip_shop_pay', 'true');
        location.assign(checkout.href);
      } catch (error) {
        uncertain = adding && !error.rejected;
        showError(uncertain ? 'Die Warenkorb-Anfrage konnte nicht bestätigt werden. Bitte prüfe zuerst deinen Warenkorb, bevor du Artikel erneut hinzufügst.' : error.message);
        element.querySelector('[data-mp-vorkasse-cart-link]').hidden = !(added || uncertain);
        busy = false; confirm.disabled = uncertain; dialog.removeAttribute('aria-busy');
        confirm.textContent = added ? 'Vorkasse-Kasse erneut öffnen' : 'Erneut versuchen';
      }
    });
    root.addEventListener('change', () => requestAnimationFrame(refresh));
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      busy = false; dialog.removeAttribute('aria-busy'); confirm.disabled = uncertain;
      confirm.textContent = added ? 'Vorkasse-Kasse erneut öffnen' : 'Weiter zur Vorkasse-Kasse';
      element.querySelector('[data-mp-vorkasse-cart-link]').hidden = !(added || uncertain);
      if (added) showError('Deine Auswahl ist bereits im Warenkorb. Du kannst den bestehenden Warenkorb erneut mit Vorkasse öffnen.');
      refresh();
    });
    instances.set(element, {refresh}); refresh();
  });
  const refreshAll = () => { init(); instances.forEach((instance, element) => { if (element.isConnected) instance.refresh(); else instances.delete(element); }); };
  ['DOMContentLoaded','mp:product-variant-change','mp:tax-role-changed','mp:tax-content-ready','currency:update','shopify:section:load','mp:variant-state-ready'].forEach(name => document.addEventListener(name, refreshAll));
  window.MiniPowerVorkasse = {init:refreshAll}; refreshAll();
  [300, 1000, 3000].forEach(delay => setTimeout(refreshAll, delay));
})();
